import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeSalary, EmployeeSalaryCreate, EmployeeSalaryFilter } from '../data/employeeSalary';

export function createEmployeeSalaryService(client: AxiosInstance) {
  return createCrudService<EmployeeSalary, EmployeeSalaryCreate, EmployeeSalaryFilter>(
    client,
    '/hrm/EmployeeSalary',
    'id',
  );
}

export type EmployeeSalaryService = CrudService<EmployeeSalary, EmployeeSalaryCreate, EmployeeSalaryFilter>;
